import React from 'react'
import {Icon} from '@chakra-ui/react'

const RadioIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M20.2649 29.5297C25.3817 29.5297 29.5297 25.3817 29.5297 20.2649C29.5297 15.148 25.3817 11 20.2649 11C15.148 11 11 15.148 11 20.2649C11 25.3817 15.148 29.5297 20.2649 29.5297Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20C1 9.50659 9.50659 1 20 1C30.4934 1 39 9.50659 39 20Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RadioIcon
